exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sliderpadding{padding-bottom:20px;padding-left:5px;padding-right:5px}", ""]);

// exports
